// Session handling shared by every API call: the token returned at login is sent
// as `Authorization: Bearer <token>`, and a 401 answer ends the session.

const AUTH_KEY = "authUser";
export const LOGOUT_EVENT = "safba:logout";

export function getAuthToken() {
  try {
    return JSON.parse(localStorage.getItem(AUTH_KEY) || "null")?.token || null;
  } catch {
    return null;
  }
}

export async function apiFetch(url, options) {
  const token = getAuthToken();
  const finalOptions = token
    ? { ...(options || {}), headers: { ...(options?.headers || {}), Authorization: `Bearer ${token}` } }
    : options;

  const res = await (finalOptions === undefined ? fetch(url) : fetch(url, finalOptions));

  if (res.status === 401 && token) {
    // Expired or revoked session: send the user back to the login page.
    localStorage.removeItem(AUTH_KEY);
    window.dispatchEvent(new Event(LOGOUT_EVENT));
  }
  return res;
}

/** Adds the token to plain links (attachments) that cannot send headers. */
export function withAccessToken(url) {
  const token = getAuthToken();
  if (!token) return url;
  return `${url}${url.includes("?") ? "&" : "?"}access_token=${encodeURIComponent(token)}`;
}
